/**
 * Schenck's ticket types
 */
export default [
  {
    key: 'device_breakdown',
    value: 'Machine standstill',
    icon: 'alert-triangle',
    color: 'signal',
    deviceInput: true,
    deviceIdentify: false,
    deviceIdentifyRegister: false,
  },
  {
    key: 'technical_issue',
    value: 'Technical support',
    icon: 'alert-square',
    deviceInput: true,
    deviceIdentify: false,
    deviceIdentifyRegister: false,
  },
  {
    key: 'clarification_spare_parts',
    value: 'Spare parts',
    icon: 'part',
    deviceInput: true,
    deviceIdentify: false,
    deviceIdentifyRegister: false,
  },
  {
    key: 'require_service',
    value: 'Service, maintenance, calibration',
    icon: 'tool',
    deviceInput: true,
    deviceIdentify: false,
    deviceIdentifyRegister: false,
  },
  {
    key: 'digital_platform',
    value: 'Schenck One',
    icon: 'webhook',
    deviceInput: true,
    deviceIdentify: false,
    deviceIdentifyRegister: false,
  },
  {
    key: 'feedback_commendation',
    value: 'Suggestions, praise, criticism',
    icon: 'message-text',
    deviceInput: false,
  },
  {
    key: 'other',
    value: 'Other',
    icon: 'dots-horizontal',
    deviceInput: false,
  },
]
